konnyScript(function($){
    
   
    
    var swiper = new Swiper("#con_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#con_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#con_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#con_swiper_slide1 .swiper-button-next',
            prevEl: '#con_swiper_slide1 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#con_swiper_slide2", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#con_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#con_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#con_swiper_slide2 .swiper-button-next',
            prevEl: '#con_swiper_slide2 .swiper-button-prev',
        },
    });
    
    
    var swiper = new Swiper("#con_swiper_slide3", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#con_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#con_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#con_swiper_slide3 .swiper-button-next',
            prevEl: '#con_swiper_slide3 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#srs_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#srs_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#srs_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#srs_swiper_slide1 .swiper-button-next',
            prevEl: '#srs_swiper_slide1 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#cody_slide1", {
        slidesPerView: 2,
        centeredSlides:true,
        loop:true,
        speed :1500,
        autoplay:{
            delay:500,
            disableOnInteraction: false,
        },
    	loopAdditionalSlides: 0,
    });
    var swiper = new Swiper("#cody_slide2", {
        slidesPerView: 2,
        centeredSlides:true,
        loop:true,
        speed :1500,
        autoplay:{
            delay:500,
            disableOnInteraction: false,
        },
    	loopAdditionalSlides: 0,
    });
    var swiper = new Swiper("#cody_slide3", {
        slidesPerView: 2,
        centeredSlides:true,
        loop:true,
        speed :1500,
        autoplay:{
            delay:500,
            disableOnInteraction: false,
        },
    	loopAdditionalSlides: 0,
    });
    var swiper = new Swiper("#estprd_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#estprd_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#estprd_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#estprd_swiper_slide1 .swiper-button-next',
            prevEl: '#estprd_swiper_slide1 .swiper-button-prev',
        },
    });

  
    var swiper = new Swiper("#w_swiper_slide1", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        scrollbar: {
            el: '#w_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#w_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#w_swiper_slide1 .swiper-button-next',
            prevEl: '#w_swiper_slide1 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#w_swiper_slide2", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        scrollbar: {
            el: '#w_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#w_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#w_swiper_slide2 .swiper-button-next',
            prevEl: '#w_swiper_slide2 .swiper-button-prev',
        },
    });
  
    var swiper = new Swiper("#w_swiper_slide3", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        scrollbar: {
            el: '#w_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#w_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#w_swiper_slide3 .swiper-button-next',
            prevEl: '#w_swiper_slide3 .swiper-button-prev',
        },
    });
  
});